<template>
  <div>
    <div
      @click="onClickAIChatbotImportButton"
      @keydown.enter="onClickAIChatbotImportButton"
      @keydown.space="onClickAIChatbotImportButton"
      v-aha-emit-action
      name="editor-import-button"
      class="text-center"
      :class="{'disabled': isButtonDisabled}"
      tabindex="0"
      role="button"
    >
      <aha-icon
        v-if="!isUploadingOrImportingSlides"
        name="import"
        width="20"
        height="21"
        viewBox="0 0 24 25"
        class="text-secondary-100"
      />
      <aha-spinner v-if="isUploadingOrImportingSlides" />
      <p class="text-xs pt-1">
        {{ $i18nPresenter.t("Import") }}
      </p>
    </div>
    <aha-toggle-tip v-if="tooltipProps" v-bind="tooltipProps" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadingTooltipMixin from '@/mixins/UploadingTooltipMixin'

export default {
  name: 'AIChatbotImportButton',

  mixins: [UploadingTooltipMixin],

  props: {
    isSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // tooltipProps and tooltipCallId will be merged from mixin
      tooltipPlacement: 'right-top',
      tooltipTarget: 'editor-import-button',
    }
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', [
      'isCurrentPresentationImportingSlides',
      'isUploadingOrImportingSlides',
    ]),

    isButtonDisabled() {
      return this.isSelectMode && this.isCurrentPresentationImportingSlides
    },
  },

  methods: {
    ...mapActions('aiChatbotImportPptxPdf', ['setIsAIChatbotImportModalVisibleV2Action']),

    onClickAIChatbotImportButton() {
      if (this.isCurrentPresentationImportingSlides) {
        return
      }
      this.setIsAIChatbotImportModalVisibleV2Action(true)
    },
  },
}
</script>
